module.exports = __webpack_public_path__ + "static/media/chevron-left-solid.dc880f17.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/img/chevron-left-solid.svg
// module id = 145
// module chunks = 0